import { useEffect, useState } from 'react';
import { fetchEnergySummary } from '../services/meter.api';
import { normalizeEnergyForChart } from '../utils/meterDetails.helpers';

export function useEnergySummary({ meterNumber, meterType, range, evn }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!meterNumber) {
      setData([]);
      return;
    }

    let alive = true;
    setLoading(true);

    (async () => {
      try {
        const params = { meter: meterNumber };
        if (range?.start && range?.end) {
          params.from = range.start;
          params.to = range.end;
        }
        if (evn !== undefined) {
          params.evn = evn;
        }
        const rows = await fetchEnergySummary(params);
        if (!alive) return;
        setData(normalizeEnergyForChart(rows, meterType));
      } catch {
        if (!alive) return;
        setData([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [meterNumber, meterType, range?.start, range?.end, evn]);

  return { data, loading };
}
